'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    OprerationsItemView: {
        displayName: 'OprerationsItemView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Operations/default/OperationsItemView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var OprerationsItemView = _wrapComponent('OprerationsItemView')(function (_Component) {
    (0, _inherits3.default)(OprerationsItemView, _Component);

    function OprerationsItemView() {
        (0, _classCallCheck3.default)(this, OprerationsItemView);
        return (0, _possibleConstructorReturn3.default)(this, (OprerationsItemView.__proto__ || (0, _getPrototypeOf2.default)(OprerationsItemView)).call(this));
    }

    (0, _createClass3.default)(OprerationsItemView, [{
        key: 'render',
        value: function render() {
            var item = this.props.item;

            var payClass = void 0,
                payMark = void 0,
                mark = void 0,
                currencyName = void 0;

            if (item.amount < 0) {
                payClass = "text_color_red";
                payMark = "";
            } else {
                payClass = "text_color_green";
                payMark = "+";
            }
            if (item.type === 'WRITE_OFF') {
                payClass = "text_color_red";
                payMark = "";
            } else {
                payClass = "text_color_green";
                payMark = "+";
            }
            if (item.currency === 'points' || item.currency === 'PTS') {
                currencyName = this.props.lang['store.iBonus.operations.Points'];
            } else {
                currencyName = this.props.lang['store.iBonus.operations.Ruble'];
            }

            var dateTime = (0, _moment2.default)(item.date).format('DD.MM.YYYY HH:mm');
            return _react3.default.createElement(
                'div',
                { className: 'row no-margin table_row' },
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-12 col-md-4 no-margin header_date' },
                    dateTime
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-4 col-sm-4 col-md-4 no-margin price_holder ' + payClass },
                    payMark + parseFloat(item.amount || 0).toFixed(2),
                    mark ? _react3.default.createElement(
                        'span',
                        { className: 'list_operations_mark' },
                        ' ',
                        mark,
                        ' '
                    ) : null
                ),
                _react3.default.createElement(
                    'div',
                    { className: 'col-xs-12 col-sm-12 col-md-4 no-margin price_holder' },
                    currencyName
                )
            );
        }
    }]);
    return OprerationsItemView;
}(_react2.Component));

exports.default = OprerationsItemView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Operations/default/OperationsItemView.jsx
// module id = 1700
// module chunks = 0